module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/3-ecf92cc446d80ae8d8994901d3bceb81.png";